<!--订单列表-->
<template>
  <div>
    <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
      <van-tab title="全部"></van-tab>
      <van-tab title="待付款"></van-tab>
      <van-tab title="待拼团"></van-tab>
      <van-tab title="待发货"></van-tab>
      <van-tab title="待收货"></van-tab>
      <van-tab title="售后中"></van-tab>

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="row-list"
            v-for="(order, index) in list"
            @click="goOrderDetail(order.id,order.type, order)"
          >
            <div class="justify-space-flex row-title">
              <div class="title-left flex-start gray">
                <img class="row-title-img" :src="order.business_pic_url" alt />
                {{order.business_name}}
              </div>

              <div class="title-right">{{order.status_buttons.name}}</div>
            </div>
            <div class="justify-space-flex row-goods" v-for="(goods, index) in order.items">
              <div class="row-left flex-start">
                <img class="row-left-img" :src="goods.pic_url" alt />
                <div class="goods-detail">
                  <div class="goods-name">{{goods.title}}</div>
                  <div class="goods-weight gray-light">{{goods.sku.sku_formart}}</div>
                </div>
              </div>
              <div class="row-right">
                <div class="goods-price">
                  <span>¥</span>
                  {{goods.goods_price_base}}
                </div>
                <div class="goods-num gray-light">数量 {{goods.count}}</div>
              </div>
            </div>

            <van-notice-bar
              :text="'可用时限'+ order.use_time_range[0] +'  ~  '+order.use_time_range[1]"
              v-if="order.use_time_range"
            ></van-notice-bar>
            <div class="row-btn">
              <div
                :class="btn.class+'-btn'"
                v-for="(btn,index) in order.status_buttons.buttons"
              >{{btn.name}}</div>
              <!--<div class="look-order">查看订单</div>
              <div class="invite-btn">邀请好友来拼团</div>-->
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </van-tabs>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
  </div>
</template>
<style scoped>
@import "../../assets/style/amendVant.css";

.normal-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-left: 15px;
}

.primary-btn {
  width: 105px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: rgba(255, 0, 0, 1);
  border-radius: 4px;
  margin-left: 15px;
}

.row-list {
  border-bottom: 0.1rem solid #efefef;
}

.row-title-img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
  border-bottom: 1px solid #efefef;
}

.title-right {
  color: #fd2840;
}

.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #efefef;
}

.goods-name {
  font-size: 12px;
  margin-bottom: 0.6rem;
}

.goods-price {
  font-size: 16px;
  color: #fd2840;
  margin: 0.1rem 0 0.6rem;
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  width: 1.5rem;
  height: 0.52rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 1);
  text-align: center;
  margin-right: 0.3rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}
</style>

<script>
import { Tab, Tabs, PullRefresh, List, NoticeBar, Toast } from "vant";
import LoginDialog from "@/components/LoginDialog.vue";

export default {
  name: "PartnerOrderList",
  components: {
    Tab,
    Tabs,
    Toast,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [NoticeBar.name]: NoticeBar,
    LoginDialog
  },
  data: function() {
    return {
      loginShow: false,
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        p: 1,
        step: 5,
        status: 0
      },
      homeTop: 0,
      list: []
    };
  },
  filter: {},
  activated() {
    let that = this;
    document.title = "订单列表";

    // console.log(this.$route.meta)
    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.list = [];
      that.active = 0;
      that.params.p = 1;
      that.params.status = 0;
      that.loading = true;
      that.finished = false;
      that.getOrderList();

      if (this.$route.query.status) {
        that.active = that.params.status = this.$route.query.status;

        console.log(that.active);
      }
    }
    document.getElementById("app").scrollTop = this.homeTop || 0;
    this.$route.meta.isBack = false;
  },
  mounted() {},
  destroyed() {},
  beforeRouteEnter(to, from, next) {
    if (
      from.path == "/orderdetail" ||
      from.path == "/shoporderdetail" ||
      from.path == "/tuanshare"
    ) {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  methods: {
    
    // 获取订单来列表
    getOrderList(ref) {
      let that = this;
      this.$api.get(
        "/paadminapi/order/areaOrderList",
        that.params,
        res => {
          that.loading = false;
          that.params.p += 1;

          if (res.data.currentpage == 1) {
            if (ref) {
              that.$toast("刷新成功");
            }
            that.isLoading = false;
            that.list = res.data.list;
          } else {
            let list = that.list.concat(res.data.list);
            that.list = list;
          }
          if (res.data.list.length == 0) {
            that.finished = true;
          }
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getOrderList();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },

    // 更改状态
    onStatusChange(index) {
      let that = this;
      that.params.status = index;
      that.params.p = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.status = 0;
      that.getOrderList();
    },

    // 跳转订单详情
    goOrderDetail(id, type, order) {
      // 判断是否成团

      if (
        order.status_buttons.buttons[0] &&
        order.status_buttons.buttons[0].type == "tuanShare"
      ) {
        let url = "tuanshare";
        rbLink({
          name: url.substring(0, 1).toUpperCase() + url.substring(1),
          query: { id: id }
        });

        return;
      }

      let url = "";
      if (type == "base") {
        url = "PartnerOrderDetail";
      }  
  
      rbLink({
        name: url.substring(0, 1).toUpperCase() + url.substring(1),
        query: { id: id }
      });
    },

    // 上拉加载
    onLoad() {
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.getOrderList();
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      this.getOrderList(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// PartnerOrderList.vue?39179dcf